interface FilterButtonsProps {
  activeCategory: string;
  onCategoryChange: (category: string) => void;
}

export default function FilterButtons({ activeCategory, onCategoryChange }: FilterButtonsProps) {
  const categories = [
    { id: 'all', label: '전체보기' },
    { id: 'woodmold', label: '목형 제작' },
    { id: 'cutting', label: '레이저 커팅' },
    { id: 'marking', label: '레이저 마킹' }
  ];

  return (
    <div className="flex flex-wrap justify-center gap-3 mb-12">
      {categories.map((category) => (
        <button
          key={category.id}
          onClick={() => onCategoryChange(category.id)}
          className={`px-8 py-3 rounded-lg font-semibold text-base transition-all duration-300 whitespace-nowrap cursor-pointer ${
            activeCategory === category.id
              ? 'bg-slate-800 text-white shadow-lg'
              : 'bg-slate-100 text-slate-700 hover:bg-slate-200'
          }`}
        >
          {category.label}
        </button>
      ))}
    </div>
  );
}
